import { styled } from "theme/default/styled";
import { setFlexDFAIC } from "theme/setter/setFlexValues/setFlexDFAIC";

export const SLeftControls = styled.div`
  ${setFlexDFAIC};
`;
